export const getLatLng = ({ latitude: lat, longitude: lng }) => ({ lat, lng });
